import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import Retracked from 'js/app/retracked';

import ApplicationStore from 'bundles/ssr/stores/ApplicationStore';

import 'css!pages/saml-sso/styl/all';

type PropsFromStores = {
  requestCountryCode: string;
  csrfToken: string;
};

type PropsFromCaller = {
  children: React.ReactNode;
  params: $TSFixMe;
};

type PropsToComponent = PropsFromStores & PropsFromCaller;

class SamlSsoApplication extends React.Component<PropsToComponent> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  declare context: LegacyContextType<typeof SamlSsoApplication.contextTypes>;

  static childContextTypes = {
    csrfToken: PropTypes.string,
    requestCountryCode: PropTypes.string,
  };

  static statics = {
    storeListeners: [ApplicationStore],
  };

  getChildContext() {
    const { csrfToken, requestCountryCode } = this.props;
    return { csrfToken, requestCountryCode };
  }

  render() {
    const { children } = this.props;
    return <div className="rc-SamlSsoApplication">{children}</div>;
  }
}

const TrackedSamlSsoApplication = Retracked.createTrackedContainer<PropsToComponent>(({ params }) => ({
  namespace: {
    app: 'saml_sso',
    page: 'saml_sso',
  },
  params,
}))(SamlSsoApplication);

export default connectToStores<PropsToComponent, PropsFromCaller>(['ApplicationStore'], (context) => ({
  csrfToken: context.ApplicationStore.getState().csrfToken,
  requestCountryCode: context.ApplicationStore.getState().requestCountryCode,
}))(TrackedSamlSsoApplication);
